import React from "react";
import PropTypes from "prop-types";
import { META } from "./estados";

const SORTS = [
  { k: "delay", label: "Más demoradas" },
  { k: "salidas", label: "Más salidas" },
  { k: "name", label: "Ruta" },
];

export const Pill = ({ st }) => (
  <span className="ms-pill" style={{ background: META[st].bg }}>
    <span className="ms-dot" style={{ background: META[st].dot }}></span>
    {META[st].label}
  </span>
);

Pill.propTypes = {
  st: PropTypes.string,
};

const RutasTable = ({ rows, total, cnt, filter, setFilter, sort, setSort, search, setSearch, selectedId, onSelect }) => {
  const chips = [
    { k: "all", label: "Todas", n: total, dot: null },
    { k: "crit", label: "Críticas", n: cnt.crit, dot: META.crit.dot },
    { k: "late", label: "Demoradas", n: cnt.late, dot: META.late.dot },
    { k: "ok", label: "Al día", n: cnt.ok, dot: META.ok.dot },
    { k: "nodata", label: "Sin salidas hoy", n: cnt.nodata, dot: META.nodata.dot },
  ];

  return (
    <section className="ms-card">
      <div className="ms-table-head">
        <div className="ms-row-between">
          <h2>Salidas por ruta (cliente)</h2>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#5c5c64" }}>
            <span>Ordenar</span>
            <div className="ms-segmented">
              {SORTS.map((s) => (
                <button key={s.k} type="button" aria-pressed={s.k === sort} onClick={() => setSort(s.k)}>
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="ms-filters">
          <label className="ms-search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <circle cx="11" cy="11" r="7"></circle>
              <line x1="21" y1="21" x2="16.5" y2="16.5"></line>
            </svg>
            <span className="visually-hidden">Buscar ruta o cliente</span>
            <input
              type="search"
              placeholder="Buscar ruta o cliente…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }} role="group" aria-label="Filtrar por estado">
            {chips.map((c) => {
              const on = c.k === filter;
              return (
                <button key={c.k} type="button" className="ms-chip" aria-pressed={on} onClick={() => setFilter(c.k)}>
                  <span className="ms-dot" style={{ background: c.dot ?? (on ? "#ffffff" : "#0e0e0f") }}></span>
                  {c.label}
                  <span className="ms-mono">{c.n}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="ms-scroll-x">
        <div style={{ minWidth: 1000 }}>
          <div className="ms-grid-rutas ms-thead">
            <span>Ruta</span>
            <span>Cliente</span>
            <span style={{ textAlign: "right" }}>Salidas</span>
            <span style={{ textAlign: "right" }}>En curso</span>
            <span style={{ textAlign: "right" }}>Finalizadas</span>
            <span style={{ textAlign: "right" }}>Pendientes</span>
            <span>Última actualización</span>
            <span>Estado</span>
          </div>
          {rows.map((r) => (
            <button
              key={r.id}
              type="button"
              className="ms-grid-rutas ms-route-row"
              aria-pressed={r.id === selectedId}
              onClick={() => onSelect(r.id)}
            >
              <span style={{ fontWeight: 700, minWidth: 0 }}>{r.name}</span>
              <span style={{ color: "#3d3d43" }}>{r.cliente}</span>
              <span className="ms-num" style={{ fontWeight: 700 }}>{r.salidas}</span>
              <span className="ms-num">{r.curso}</span>
              <span className="ms-num">{r.fin}</span>
              <span className="ms-num">{r.pend}</span>
              <span style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <span className="ms-ago">
                  <span className="ms-mono" style={{ fontWeight: 500 }}>{r.lastTime}</span>
                  <span style={{ color: r.agoColor }}>{r.ago}</span>
                </span>
                <span className="ms-meter">
                  <span style={{ width: `${r.barW}%`, background: META[r.st].dot }}></span>
                </span>
              </span>
              <span>
                <Pill st={r.st} />
              </span>
            </button>
          ))}
          {rows.length === 0 && <div className="ms-empty">No hay rutas con este estado.</div>}
        </div>
      </div>
      <div className="ms-table-foot">
        Mostrando {rows.length} de {total} rutas · selecciona una ruta para ver sus salidas
      </div>
    </section>
  );
};

RutasTable.propTypes = {
  rows: PropTypes.array,
  total: PropTypes.number,
  cnt: PropTypes.object,
  filter: PropTypes.string,
  setFilter: PropTypes.func,
  sort: PropTypes.string,
  setSort: PropTypes.func,
  search: PropTypes.string,
  setSearch: PropTypes.func,
  selectedId: PropTypes.number,
  onSelect: PropTypes.func,
};

export default RutasTable;
